import React, { useState, useEffect } from 'react';
import {
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  DropdownItem,
} from 'reactstrap';
import {
  get,
  includes,
} from 'lodash';
import { MDTApp } from '../../../../../actions/bootAction.js';
import './toolbarProfile.css';
import { IconSet } from '../../../../atoms/mdt-iconset/index.js';
import { connect } from 'react-redux';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';
import { Fragment } from 'react';

const ToolbarProfile = (props) => {
  const appid = MDTApp.getSetting('appid');
  const { customerName = '', classes, isInternalUser, t, customersListData, supportedSuppliers, userConfig } = props;
  const supplier = get(customersListData, 'suppliersIds[0]');
  const showNewNotificationPreferences = supplier && includes(supportedSuppliers, supplier) || false;
  const PREFERENCES_TABS = MDTApp.getSetting('accountPreferencesTabIds');

  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (dropdownOpen) {
      const eventParamObj = {
        eventCategory: 'globalHeader',
        eventAction: 'profileMenu',
        eventLabel: props.pageName,
        processLabels: false,
      };
      sendEventTrackingData(eventParamObj);
    }
  }, [dropdownOpen, props]);

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const redirectUserProfile = (hash) => {
    const url = MDTApp.getSetting('links.portal-edit-profile-v2'); //this is coming from cent-app
    const userPreferences = MDTApp.getSetting('links.userPreferences') || ''; //this is coming from dashboard-app
    const eventParamObj = {
      eventCategory: 'globalHeader',
      eventAction: 'profileSubMenu',
      eventLabel: 'View Profile',
      processLabels: false,
    };
    sendEventTrackingData(eventParamObj);
    if (appid === window.MDTSetting.authAppId) { //if app is portal
      userPreferences && MDTApp.goto(userPreferences + "#" + hash);
    }
    else MDTApp.goto(url + "#" + hash);
  };

  const logout = (e) => {
    e.preventDefault();
    const { isInternalUser } = props;
    const dateTime = new Date().toJSON();
    const userType = isInternalUser === 'True' ? 'Internal' : 'External';
    const eventLabel = `Logout_${userType} : ${dateTime}`;
    const eventParamObj = {
      eventCategory: 'accManagement',
      eventAction: 'logout',
      eventLabel,
      processLabels: false,
    };
    sendEventTrackingData(eventParamObj);
    MDTApp.logout();
  };

  const reqAddlAccess = (e) => {
    const url = MDTApp.getSetting('links.request-additional-access');
    const eventParamObj = {
      eventCategory: 'globalHeader',
      eventAction: 'profileSubMenu',
      eventLabel: 'Request Additional Access',
      processLabels: false,
    };
    sendEventTrackingData(eventParamObj);
    if (appid === window.MDTSetting.authAppId) props.redirectTo(url);
    else MDTApp.goto(url);
  };

  const isInternal = isInternalUser.toLowerCase() === 'true';
  const showReqAddlAccess =
    !!MDTApp.getSetting('features.requestAdditionalAccessEnabled') &&
    !isInternal &&
    props.getResourceAccess('AdditionalRoles', 'Read');

  return (
    <div className={classes}>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle caret>
          <span className="body2 p-active display-name px-sm-5">
            <IconSet name="User-new" className="user-profile" />
            <span className="d-none d-sm-block">{customerName}</span>
          </span>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem divider />
          <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.ACCOUNT)}>
            <span
              className="menu-text body2 p-active"
              data-auid="header-view-profile-link"
              data-test="viewProfile"
            >
              {t('myProfile')}
            </span>
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.ACCOUNT)}>
            <span
              className="menu-text body2 p-active"
              data-auid="header-view-profile-link"
              data-test="passwordSecurity"
            >
              {t('passwordSecurity')}
            </span>
          </DropdownItem>
          {
            !userConfig?.configuration?.hideNotificationPreferences && (
              <Fragment>
                <DropdownItem divider />
                <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.NOTIFICATION)}>
                  <span
                    className="menu-text body2 p-active"
                    data-auid="header-view-profile-link"
                    data-test="notificationPreferences"
                  >
                    {t('notificationPreferences')}
                  </span>
                </DropdownItem>
              </Fragment>
            )
          }
          {
            !!showNewNotificationPreferences && (
              <Fragment>
                <DropdownItem divider />
                <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.NOTIFICATIONID2)}>
                  <span
                    className="menu-text body2 p-active"
                    data-auid="header-view-profile-link"
                    data-test="manageNotification"
                  >
                    {t('manageNotification')}
                  </span>
                </DropdownItem>
              </Fragment>
            )
          }
          {
            !userConfig?.configuration?.hidePaymentAndInvoicePreferences && (
              <Fragment>
                <DropdownItem divider />
                <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.CREDITCARD)}>
                  <span
                    className="menu-text body2 p-active"
                    data-auid="header-view-profile-link"
                    data-test="paymentPreferences"
                  >
                    {t('paymentPreferences')}
                  </span>
                </DropdownItem>
              </Fragment>
            )
          }
          {
              (!userConfig?.configuration?.hideNotificationPreferences || showNewNotificationPreferences) && (
              <Fragment>
                <DropdownItem divider />
                <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.NOTIFICATION)}>
                  <span
                    className="menu-text body2 p-active"
                    data-auid="header-view-profile-link"
                    data-test="alerts"
                  >
                    {t('alerts')}
                  </span>
                </DropdownItem>
              </Fragment>
            )
          }
          <DropdownItem divider />
          {showReqAddlAccess && (
            <DropdownItem onClick={() => reqAddlAccess()}>
                <span className="menu-text body2 p-active" data-test="requestAdditionalAccess" title={t('requestAdditionalAccess')}>{t('requestAdditionalAccess')}</span>
            </DropdownItem>
            )
          }
          {showReqAddlAccess && <DropdownItem divider />}
          <DropdownItem onClick={logout}>
            <span className="menu-text body2 p-active" data-test="logout">
              {t('logout')}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    customerName: !!state.meDetails.user ? state.meDetails.user.name || '' : '',
    pageName: state.page,
    isInternalUser: state.meDetails.isInternal || 'false',
    customersListData: get(state, 'meDetails.customer', {}),
    supportedSuppliers: get(state, 'meDetails.supportedSuppliers', []),
    userConfig: get(state, 'formConfig.featureConfiguration.ProfilePreferences', {}),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectTo: (page, data) =>
      dispatch({ type: page, payload: { filter: data } }),
    sso: (redirectFlag, editProfileUrl) =>
      dispatch(MDTApp.sso(redirectFlag, editProfileUrl)),
    getResourceAccess: (resource, action) =>
      dispatch(MDTApp.getResourceAccess(resource, action)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarProfile);
